import styled from '@emotion/styled'

export const Button = styled.button<{ size: number }>`
  align-items: center;
  background-image: none;
  background-color: transparent;
  border: none;
  display: flex;
  flex: 0 0 ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  justify-content: center;
  margin: 4px;
  padding: 0;
  pointer-events: auto;
  position: relative;
  width: ${({ size }) => size}px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`

export const Link = Button.withComponent('a')

export const Badge = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  line-height: 0;
  height: 10px;
  width: 10px;
  background: var(--badge-highlight);
  border-radius: 50%;
`
